<template>
    <div class="tiptap-heading">

    <bubble-menu class="bubble-menu d-flex flex-row align-items-end" :editor="editor" :tippy-options="{ duration: 100, placement: 'bottom', }" v-if="editor">
      <button @click="editor.chain().focus().toggleBold().run()" :class="[{ 'active': editor.isActive('bold') },'btn', 'btn-light',' btn-sm']">
        <i class="fa fa-bold" />
      </button>
      <button @click="editor.chain().focus().toggleItalic().run()" :class="[{ 'active': editor.isActive('italic') },'btn', 'btn-light',' btn-sm']">
        <i class="fa fa-italic" />
      </button>
      <button @click="editor.chain().focus().toggleUnderline().run()" :class="[{ 'active': editor.isActive('underline') },'btn', 'btn-light',' btn-sm']">
        <i class="fa fa-underline" />
      </button>
      <button @click="editor.chain().focus().toggleStrike().run()" :class="[{ 'active': editor.isActive('strike') },'btn', 'btn-light',' btn-sm']">
        <i class="fa fa-strikethrough" />
      </button>
      <button @click="showSwatches=!showSwatches" :class="[{ 'active': editor.isActive('strike') },'btn', 'btn-light',' btn-sm']" alt="Text Colour" title="Text Colour">
        <i class="fa fa-paint-brush" />
      </button>
      <div class="d-flex swatch-wrap" v-if="showSwatches">

        

        <template v-for="color in swatches">
          <button  @click="editor.chain().focus().setColor(color).run();showSwatches=false;" :class="['btn', 'btn-light',' btn-sm']" :style="'color:'+color+';'">
            <i class="fa fa-square" />
          </button>
        </template>

        <button @click="showVueColorModal" :class="['btn', 'btn-light',' btn-sm']"  alt="Text Colour" title="Text Colour">
          <i class="fa fa-eyedropper" />
        </button>

        <button v-if="editor.getAttributes('textStyle').color" @click="editor.chain().focus().unsetColor().run();showSwatches=false;" :class="['btn', 'btn-light',' btn-sm']" alt="Unset Colour" title="Unset Colour">
          <i class="fa fa-eraser" />
        </button>

      </div>

    </bubble-menu>

    <b-modal size="lg" ref="vue-color-modal" id="vue-color-modal" hide-footer hide-header-close title="Colour Picker" v-if="editor">
      
          <vue-color class="vue-color-picker-text" :preset-colors="presetColors" :disable-alpha="true" @input="setColor"
          :value="editor.getAttributes('textStyle').color ? editor.getAttributes('textStyle').color : '#000000'" @cancel="cancelColor" @ok="okColor">
          </vue-color>
        
    </b-modal>

    <editor-content :editor="editor" v-if="editor" />
  </div>
</template>

<script>

import { Color } from '@tiptap/extension-color'  
import Document from '@tiptap/extension-document'
import StarterKit from '@tiptap/starter-kit'
import TextStyle from '@tiptap/extension-text-style'
import Underline from '@tiptap/extension-underline'
import HardBreak from '@tiptap/extension-hard-break'
import Link from '@tiptap/extension-link'

import { BubbleMenu,Editor, EditorContent } from '@tiptap/vue-2'

import VueColor from 'vue-color/src/components/Photoshop.vue';


const CustomDocument = Document.extend({
  content: 'inline*',
})

export default {
  components: {
    EditorContent,
    BubbleMenu,
    'vue-color' : VueColor,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    swatches:{
      
    },
    elementIndex:null,
    insert:{},
  },

  data() {
    return {
      editor: null,
      presetColors: this.swatches,
      showPicker: false,
      showSwatches: false,
      selectedColor: '#000000',
    }
  },

  watch: {
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },
  created() {
    this.insert.$on('shortcode', (args) => {
      if(args.elementIndex == this.elementIndex){ // If we are intended target then insert
        this.editor.commands.insertContent(args.data);
      }
    });
  },
  mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [
        CustomDocument,
        StarterKit.configure({document: false,hardBreak: false,}),
        TextStyle,
        Color,
        Underline,        
        Link.configure({
          openOnClick: false,
        }),
        HardBreak.extend({
          addKeyboardShortcuts () {
            return {
              Enter: () => this.editor.commands.setHardBreak()
            }
          }
        })
      ],
      onUpdate: () => {
        // HTML
        this.$emit('input', this.editor.getHTML())

        // JSON
        // this.$emit('input', this.editor.getJSON())
      },
      onSelectionUpdate: () => {
        this.showPicker = false;
        this.showSwatches = false;
      }
    })


  },

  beforeDestroy() {
    this.editor.destroy()
  },

  methods: {
    okColor: function(){
      var editor = this.editor;
      editor.chain().focus().setColor(this.selectedColor).run();
      this.showSwatches = false;
      this.hideVueColorModal();
    },
    cancelColor: function(){
      this.showSwatches = false;
      this.selectedColor = '#000000';
      this.hideVueColorModal();
    },
    setColor: function($event){
      this.selectedColor = $event.hex;
    },

    setLink() {
      const previousUrl = this.editor.getAttributes('link').href
      const url = window.prompt('URL', previousUrl)

      // cancelled
      if (url === null) {
        return
      }

      // empty
      if (url === '') {
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .unsetLink()
          .run()

        return
      }

      // update link
      this.editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({ href: url })
        .run()
    },
    showVueColorModal(){
      this.$refs['vue-color-modal'].show();
    },
    hideVueColorModal(){
      this.$refs['vue-color-modal'].hide();
    }
  }
}
</script>

<style lang="scss">
/* Basic editor styles */
.tiptap-heading .ProseMirror {
  > * + * {
    margin-top: 0em;
  }
}
</style>
<style >

.tiptap-heading .ProseMirror:focus {
    outline: none;
  }

.tiptap-heading .vue-color-picker{
  position: absolute;
  bottom:0;
}
.tiptap-heading .vue-color-picker-close{
  position: absolute;
  z-index: 1001;
  top: -268px;
  left: 292px;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, .15), 0 8px 16px rgba(0, 0, 0, .15);
  background: #fff;
  padding: 0px;
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 1;
}
.tiptap-heading .bubble-menu .btn{
  margin-right: 2px;
  border: 1px solid rgba(0,0,0,0.25); 
  width: 26px;
  height: 26px;
  line-height: 17px;
text-indent: -1px;
}
.tiptap-heading .bubble-menu .btn:hover{
  border: 1px solid rgba(0,0,0,0.5);  
}
#vue-color-modal .modal-body{
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
}
#vue-color-modal  div.vc-photoshop{
  border-width: 0;
}
</style>